import {
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Box,
  Stack,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ImportLayout from "../../components/LayoutWithHeader.js";
import BetaPill from "../../components/BetaPill";
import { IMPORT_SOURCES } from "./importSources";
import { getContentOptions } from "../../utils/utils.js";

export default function ImportLanding() {
  const navigate = useNavigate();
  const contentOptions = getContentOptions();

  return (
    <ImportLayout title="Import an existing library" showBackButton={false}>
      <Typography sx={{ mb: 3 }}>
        Already tracking elsewhere? Import your existing library in just a few
        minutes. Select a source below to get started. Don’t see yours yet?
        <Link
          href="https://app.youform.com/forms/fghdoj5a"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ ml: 0.5 }}
        >
          Request a new import source
        </Link>
      </Typography>

      <Grid container spacing={2}>
        {Object.values(IMPORT_SOURCES).map((source) => {
          return (
            <Grid item xs={6} sm={3} key={source.key}>
              <Card
                sx={{
                  height: "100%",
                  boxShadow: "none",
                  bgcolor: (theme) =>
                    theme.palette.mode === "dark"
                      ? theme.palette.background.paper
                      : theme.palette.secondary.main,
                }}
              >
                <CardActionArea
                  onClick={() => navigate(`/import/${source.key}`)}
                >
                  <CardContent
                    sx={{
                      position: "relative",
                      minHeight: 120,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* Content Type Icon(s) - top left */}
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        color: "text.secondary",
                        opacity: 0.7,
                      }}
                    >
                      {source.contentType.map((type) => (
                        <Box
                          key={type}
                          sx={
                            type === "tvshow"
                              ? { position: "relative", top: "-2px" }
                              : undefined
                          }
                        >
                          {contentOptions[type]?.icon}
                        </Box>
                      ))}
                    </Stack>

                    {/* Beta pill - top right */}
                    {source.beta && (
                      <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                        <BetaPill />
                      </Box>
                    )}

                    {/* Centered Label */}
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {source.label}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </ImportLayout>
  );
}
